import type {
  ISupportMessage,
  ISupportTicket,
  SupportTicketClosedReason,
  SupportTicketStatus,
} from '@/domain/entities/support';

export const SUPPORT_QUEUE_STATUSES: SupportTicketStatus[] = ['open', 'closed'];

export interface SupportTicketListResponse {
  items: ISupportTicket[];
  total: number;
  limit?: number;
  nextToken?: string | null;
}

export interface SupportTicketThreadResponse {
  ticket: ISupportTicket;
  messages: ISupportMessage[];
}

export interface ReplyToSupportTicketRequest {
  ticketID: string;
  body: string;
  photos?: null;
}

export interface UpdateSupportTicketStatusRequest {
  ticketID: string;
  status: 'open';
  awaiting: 'support' | 'user';
  closedReason?: never;
}

export interface CloseSupportTicketRequest {
  ticketID: string;
  status: 'closed';
  closedReason: Extract<SupportTicketClosedReason, 'resolved' | 'closed_by_support'>;
  awaiting?: never;
}

export interface UpdateSupportTicketStatusResponse {
  ticket: ISupportTicket;
  systemMessage: ISupportMessage | null;
}

export interface FetchSupportTicketsByStatusArgs {
  status: SupportTicketStatus;
  limit?: number;
  nextToken?: string;
}

export interface FetchSupportTicketsByPropertyArgs {
  propertyID: string;
  limit?: number;
  nextToken?: string;
}

export type SupportQueueStatus = SupportTicketStatus;
export type SupportStatusUpdateRequest = UpdateSupportTicketStatusRequest | CloseSupportTicketRequest;

export interface SupportState {
  activeQueueStatus: SupportQueueStatus;
  itemsByStatus: Record<SupportQueueStatus, ISupportTicket[]>;
  hasFetchedByStatus: Record<SupportQueueStatus, boolean>;
  isListingByStatus: Record<SupportQueueStatus, boolean>;
  errorByStatus: Record<SupportQueueStatus, string | null>;
  nextTokenByStatus: Record<SupportQueueStatus, string | null>;
  totalByStatus: Record<SupportQueueStatus, number>;

  selectedTicket: ISupportTicket | null;
  selectedMessages: ISupportMessage[];
  isLoadingThread: boolean;
  threadError: string | null;

  isReplying: boolean;
  replyError: string | null;

  isUpdatingStatus: boolean;
  updateStatusError: string | null;
}
